import Icon from '../components/Icon.vue'

Icon.register({
  'cash-register': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M511.1 378.8c0.6 3.5 0.9 7 0.8 10.5v90.7c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-90.8c0-3.5 0.3-7 0.9-10.5l26.7-160c2.6-15.4 16-26.7 31.6-26.7h84.9v-64h-96c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v96.1c0 8.8-7.2 16-16 16h-96v64h244.8c15.7 0 29 11.3 31.6 26.7zM280 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zM248 312c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zM216 232h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM80 80h192v-32h-192v32zM120 280c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16zM136 344c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16zM352 456v-16c0-4.4-3.6-8-8-8h-176c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8zM376 344v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16zM424 264v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cash-register.js
// module id = 1164
// module chunks = 0